/**
 * URLs for a grammar-tip `video_key` (e.g. `grammar/now-vs-usually-v1`).
 * Videos live on R2 next to the audio (scripts/upload-video.mjs) and have no
 * local pipeline, so dev plays the same files as prod. `VITE_VIDEO_BASE`
 * overrides the base. A plain <video src> needs no CORS, so *.pages.dev
 * previews play them too (unlike the Web Audio clips).
 */
const BASE =
  (import.meta.env.VITE_VIDEO_BASE as string | undefined)?.replace(/\/+$/, '') ??
  'https://audio.fluent.ge/video';

export function videoUrl(videoKey: string): string {
  return `${BASE}/${videoKey}.mp4`;
}

export function videoPosterUrl(videoKey: string): string {
  return `${BASE}/${videoKey}.jpg`;
}
